import React, { useEffect, useState } from 'react'
import { Button, FormMessageError, GridContainer, Icon, Link, Modal, Spacer, useModal } from '../../../../components/UI'
import { FamilyGroupTabs } from '../../../../components/Dashboard/FamilyGroup/FamilyGroupTabs/FamilyGroupTabs'
import { CardFamilyMember, FamilyGroup, FamilyGroupCardBorderless, FamilyGroupsAsMember } from '../../../../components'
import { Loading, Text } from '../../../../components/UI'
import { User } from '../../interface/User'
import { isMinorByAge } from '../../helpers/isMinorByAge'
import { useAdminFamilyGroup } from '../../hooks/useAdminFamilyGroup'
import { AdminCardFamilyMember } from '../admin-card-family-member/AdminCardFamilyMember'
import { RelationshipData } from '../../interface/RelationshipData'
import { AdminFamilyGroupsAsMember } from '../admin-family-groups-as-member/AdminFamilyGroupsAsMember'
import { RelationshipDataAsMember } from '../../interface/RelationshipDataAsMember'
import { AdminFamilyGroupRequests } from '../admin-family-group-requests/AdminFamilyGroupRequests'

export const AdminFamilyGroupTabs = ({userData}: {userData: User}) => {

    // Family Group
    const familyGroup = useAdminFamilyGroup(userData?.id);

    // Tabs
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');

    useEffect(() => {
        if(tab) {
            setActiveTab(tab);
        }
    }, []);
    
    const [activeTab, setActiveTab] = useState('family');
    const changeActiveTab = (tab: string) => {
        setActiveTab(tab);
    }

    // is minor
    const isMinor = React.useMemo(() => 
        userData.is_a_minor || isMinorByAge(userData.date_birth),
        [userData.is_a_minor, userData.date_birth]
    );

    // on family change
    const onFamilyChange = () => {
        familyGroup.getFamilies();
        familyGroup.getFamilyGroupsAsMember();
    }

    // modal
    const modal = useModal()

    const [modalContent, setModalContent] = useState({
      confirmationMessage: '',
      successMessage: '',
      action: async () => {},
    });

    const delFamily = async (id: number) => {
        console.log('delFamily', id)
      const resp = await familyGroup.deleteFamilyGroup(id);
      console.log('resp', resp)
      
      if(resp.status === 'Ok') {
        modal.setStatus('SUCCESS');
      } else {
        modal.setMessage(resp.message);
        modal.setStatus('ERROR');
      }
      modal.open();
    }

    const openConfirmationModal = ({ 
        confirmationMessage, 
        successMessage, 
        action 
      }: any) => {
        setModalContent({
          confirmationMessage,
          successMessage,
          action
        });
        modal.setStatus('');
        modal.open();
    }

    const onDelFamilyModal = (relationshipData: RelationshipData) => {
      openConfirmationModal({
        confirmationMessage: `¿Estás seguro(a) que deseas eliminar a ${relationshipData.family_patient.first_name} ${relationshipData.family_patient.last_name} del grupo familiar de ${userData.first_name} ${userData.last_name}?`,
        successMessage: `${relationshipData.family_patient.first_name} ${relationshipData.family_patient.last_name} ha sido eliminado(a) del grupo familiar de ${userData.first_name} ${userData.last_name}`,
        action: () => delFamily(relationshipData.id)
      });
    }
  
    const handleExitGroup = (relationshipData: RelationshipDataAsMember) => {
      openConfirmationModal({
        confirmationMessage: `¿Estás seguro(a) que deseas eliminar a ${userData.first_name} ${userData.last_name} del grupo familiar de ${relationshipData.patient_leader.first_name} ${relationshipData.patient_leader.last_name}?`,
        successMessage: `${userData.first_name} ${userData.last_name} ha sido eliminado(a) del grupo familiar de ${relationshipData.patient_leader.first_name} ${relationshipData.patient_leader.last_name}`,
        action: () => delFamily(relationshipData.id)
      });
    }

    return (
        <>
            <FamilyGroupTabs
                tabs={[{ title: 'Grupo familiar', setTab: 'family' }, { title: `Solicitudes`, setTab: 'requests' }]}
                activeTab={activeTab}
                changeActiveTab={changeActiveTab}
            />

            <FamilyGroupCardBorderless>
                {activeTab === 'family' &&
                    <>
                        {!isMinor ?
                            <>
                                {familyGroup.data ?
                                    <>
                                        {familyGroup.data.length > 0 ?
                                            <>
                                                <Text>1. Grupo familiar de {userData.first_name} {userData.last_name}</Text>
                                                <Spacer size='medium' />
                                                <GridContainer minWidthColumns='320px' maxWidthContainer='1200px'>
                                                    {familyGroup.data && familyGroup.data.map((relationshipData: RelationshipData) => {
                                                        return (
                                                            <AdminCardFamilyMember
                                                                relationshipData={relationshipData}
                                                                key={relationshipData.id}
                                                                onDelFamilyModal={onDelFamilyModal} 
                                                            />
                                                        )
                                                    })}
                                                </GridContainer>
                                            </>
                                            :
                                            <>
                                                <Text>1. El usuario no tiene miembros en su grupo familiar.</Text>
                                            </>

                                        }
                                    </>
                                    :
                                    <Loading align="center" />
                                }

                                <Spacer size='medium' />
                                <Link to={`/admin/familia/agregar-integrante/${userData.id}`}>Agregar miembro al grupo familiar</Link>
                                <Spacer size='xxl' />
                            </> 
                            : 
                            <>
                                <Text>1. {userData.first_name} {userData.last_name} es menor de edad y no puede tener integrantes en su grupo familiar.</Text>
                                <Spacer size='xxl' />
                            </>
                        }

                        {
                            familyGroup.familyGroupsAsMember
                                ? familyGroup.familyGroupsAsMember.length > 0
                                    ? 
                                        <>
                                            <Text>2. Grupos familiares en los que {userData.first_name} {userData.last_name} es miembro</Text>
                                            <Spacer size='medium' />
                                            <AdminFamilyGroupsAsMember data={familyGroup.familyGroupsAsMember} onExitGroup={handleExitGroup} />
                                        </>
                                    : <Text>2. {userData.first_name} {userData.last_name} no es miembro de ningún grupo familiar.</Text>
                                : <Loading align="center" />
                        }

                    </>
                }

                {activeTab === 'requests' &&
                    <AdminFamilyGroupRequests onFamilyChange={onFamilyChange} patientId={userData.id} />
                }
    

            </FamilyGroupCardBorderless>

            <Modal show={modal.show} maxWidth="345px" onClose={() => modal.close()}>
                {modal.status === '' &&
                    <div className="pt-100 pb-70 px-50 text-center">
                        <Text weight="semibold" lineHeight="6">
                            {modalContent.confirmationMessage}
                        </Text>

                        <Button 
                          onClick={modalContent.action} 
                          fullWidth 
                          className="mt-40"
                        >
                          CONFIRMAR
                        </Button>
                    </div>
                }

                {modal.status === 'SUCCESS' &&
                    <div className="py-70 px-50 text-center">
                        <Icon name="modal-success" />
                        <Text weight="semibold" lineHeight="6" className="mt-30">
                            {modalContent.successMessage}
                        </Text>
                    </div>
                }
                {modal.status === 'ERROR' &&
                    <FormMessageError
                        className="p-50"
                        message={modal.message}
                        onClick={() => modal.close()}
                    />
                }
            </Modal>

        </>

    )
}
